import {AlertCircle, CheckCircle, Clock, FileText} from 'lucide-react';

const assignments = [
    {
        student: 'علی محمدی',
        assignment: 'تمرین فصل 3 - معادلات دیفرانسیل',
        submittedAt: '2 ساعت پیش',
        status: 'pending',
        class: 'ریاضیات پیشرفته'
    },
    {
        student: 'سارا احمدی',
        assignment: 'پروژه آزمایشگاه - اندازه‌گیری',
        submittedAt: '5 ساعت پیش',
        status: 'pending',
        class: 'فیزیک'
    },
    {
        student: 'رضا کریمی',
        assignment: 'تحقیق درباره واکنش‌های شیمیایی',
        submittedAt: 'دیروز',
        status: 'reviewed',
        class: 'شیمی',
        grade: 18.5
    },
    {
        student: 'مریم حسینی',
        assignment: 'حل مسائل فصل 4',
        submittedAt: 'دیروز',
        status: 'reviewed',
        class: 'ریاضیات',
        grade: 19
    },
    {
        student: 'امیر رضایی',
        assignment: 'گزارش کار آزمایشگاه',
        submittedAt: '1 ساعت پیش',
        status: 'pending',
        class: 'آزمایشگاه'
    },
];

export default function AssignmentsSection() {
    return (
        <div className=" rounded-xl shadow-sm border dark:border-gray-600 border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
                <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                    مشاهده همه
                </button>
                <h2 className="text-lg font-bold  ">ارسال‌های اخیر تکالیف</h2>
            </div>

            <div className="space-y-3">
                {assignments.map((item, index) => (
                    <div
                        key={index}
                        className="border dark:border-gray-600 border-gray-200 rounded-lg p-4 hover:shadow-md transition-all duration-200 group"
                    >
                        <div className="flex items-center justify-between gap-4">
                            <div className="flex items-center gap-3">
                                {item.status === 'pending' ? (
                                    <button
                                        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg font-medium transition-colors">
                                        بررسی
                                    </button>
                                ) : (
                                    <div
                                        className="px-4 py-2 bg-green-50 text-green-700 text-sm rounded-lg font-medium flex items-center gap-1">
                                        <CheckCircle className="w-4 h-4"/>
                                        نمره: {item.grade}
                                    </div>
                                )}
                            </div>

                            <div className="flex-1 text-right">
                                <div className="flex items-center gap-2 justify-end mb-1">
                                    <h3 className="font-semibold  ">{item.student}</h3>
                                    {item.status === 'pending' && (
                                        <span
                                            className="px-2 py-1 bg-orange-100 text-orange-700 text-xs rounded-full font-medium flex items-center gap-1">
                      <AlertCircle className="w-3 h-3"/>
                      در انتظار
                    </span>
                                    )}
                                </div>
                                <p className="text-sm   mb-1">{item.assignment}</p>
                                <div className="flex items-center gap-4 text-xs   justify-end">
                                    <div className="flex items-center gap-1">
                                        <Clock className="w-3 h-3"/>
                                        <span>{item.submittedAt}</span>
                                    </div>
                                    <span className="text-blue-600">{item.class}</span>
                                </div>
                            </div>

                            <div
                                className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center group-hover:bg-gray-200 transition-colors">
                                <FileText className="w-5 h-5  "/>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
